import { atom } from "jotai";

import { BookingPunchPassState } from "../types";

/**
 * Stores punch pass data keyed by the booking id (for booking-level passes) or
 * round id (for round-level passes). Initialized from the booking data once.
 */
export const punchPassesByTargetIdAtom = atom<BookingPunchPassState | null>(
  null
);
